import { ApiError } from '@/api/ApiError';
import { ErrorCodes } from 'schemas';

// Reusable unknown error for consistent error handling
export const UNKNOWN_ERROR_API_ERROR = new ApiError({
  type: 'error',
  error: 'Unknown error',
  code: ErrorCodes.INTERNAL_SERVER_ERROR,
  message: 'An unknown error occurred',
});
